import { createTheme } from "@mui/material/styles";

// Layout heights root -> navbar / content
const rootHeight = "100vh";
const appNavBarHeight = "4.3rem";

// Extend module '@mui/material/styles' to add new properties
declare module "@mui/material/styles" {
  interface Theme {
    customTransitions: {
      colorTransition: string;
    };
    customLayoutHeight: {
      rootHeight: string;
      appNavBarHeight: string;
    };
  }
  interface Palette {
    customColors: {
      positiveVariationColor: string;
      negativeVariationColor: string;
      generateVideoColor: string;
      generateSummaryColor: string;
      newsPaperColor: string;
    };
  }
  // to work in sync with `createTheme`
  interface ThemeOptions {
    customTransitions?: {
      colorTransition?: string;
    };
    customLayoutHeight?: {
      rootHeight?: string;
      appNavBarHeight?: string;
    };
  }
  interface PaletteOptions {
    customColors?: {
      positiveVariationColor?: string;
      negativeVariationColor?: string;
      generateVideoColor?: string;
      generateSummaryColor?: string;
      newsPaperColor?: string;
    };
  }
}

const BaseTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#d20a11"
    },
    secondary: {
      main: "#fa6375",
      contrastText: "#ffffff"
    },
    background: {
      default: "#f7f7f7"
    },
    error: {
      main: "#ff0004"
    },
    success: {
      main: "#28a745"
    },
    customColors: {
      positiveVariationColor: "#027A48",
      negativeVariationColor: "#B42318",
      generateVideoColor: "#f3c518",
      generateSummaryColor: "#14a6d9",
      newsPaperColor: "#D8D8D8"
    }
  },
  shape: {
    borderRadius: 5
  },
  customTransitions: {
    colorTransition: "all 150ms ease-in-out"
  },
  customLayoutHeight: {
    rootHeight: rootHeight,
    appNavBarHeight: appNavBarHeight
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    }
  }
});

export default BaseTheme;
